// extracted by mini-css-extract-plugin
export var active = "_lj-2";
export var recordingDot = "_lj-1";
export var recordingIndicator = "_lj-0";